import { useDispatch, useSelector } from 'react-redux';
import { USER_FEEDBACK_MANUAL_TOP_UP } from 'src/constants/UserFeedback/Dashboard/UserFeedback';
import { useUpgradeAccountStatus } from 'src/hooks';
import { RootState } from 'src/redux/reducers/rootReducer';
import { USER_FEEDBACK_ACTION_TYPES } from 'src/redux/types/userFeedbackTypes';

export const useManualTopupTransactionModal = () => {
  const dispatch = useDispatch();
  const { isApproved } = useUpgradeAccountStatus();

  const { email, ...props } = useSelector(
    (state: RootState) => state.manualTopup,
  );

  const onClose = () => {
    dispatch({ type: 'resetManualTopup' });
    dispatch({
      type: USER_FEEDBACK_ACTION_TYPES.SHOW_USER_FEEDBACK_MODAL,
      payload: USER_FEEDBACK_MANUAL_TOP_UP,
    });
  };

  const openManualTopup = () => {
    onClose();
    if (isApproved) {
      dispatch({
        type: 'SET_TOPUP_SHOW',
      });
      return;
    }
  };

  return { email, props, onClose, openManualTopup };
};
